module.exports = __webpack_public_path__ + "assets/Education.bc9b024e.svg";